module.exports = __webpack_public_path__ + "static/media/Colette Super King Bed Base - 180x210 cm_Grey.74e2ddde.png";